import { createLocalVue, shallowMount } from "@vue/test-utils";
import ThankYou from "@/views/Gracias";
import Vuex from "vuex";

const localVue = createLocalVue();
localVue.use(Vuex);

describe("Gracias component", () => {
  let wrapper;
  let store;

  beforeEach(() => {
    store = new Vuex.Store({
      state: {
        paso1: {
          nombre: "Lara",
          apellido: "Croft",
          email: "lara@gmail.com",
          celular: {
            area: "011",
            numero: "12313212"
          },
          documento: {
            tipo: "DNI",
            numero: "35999888"
          }
        }
      },
      getters: {
        getPaso1: function (state) {
          return function () {
            return state.paso1;
          };
        }
      }
    });

    wrapper = shallowMount(ThankYou, {
      store,
      localVue
    });
  });

  it("Renders del component Gracias", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
